<template>
  <section class="frenkel-ecosistema" data-aos="zoom-in-up" data-aos-duration="1200" data-aos-offset="200"
    data-aos-easing="ease-out-cubic">
    <h2 class="frenkel-title">Ecosistema Frenkel</h2>

    <!-- Carrusel 3D con icono y etiqueta -->
    <div class="frenkel-carousel-wrapper">
      <div class="frenkel-carousel" :style="rotationStyle">
        <div v-for="(servicio, index) in serviciosArr" :key="servicio.key" class="frenkel-carousel-item"
          :style="getItemStyle(index)" :class="{ active: index === activeIndex }" @click="setActive(index)">
          <img v-if="servicio?.images?.icon" :src="servicio.images.icon"
            :alt="servicio.titles[selectedLang] || servicio.titles['es']" class="frenkel-item-img" />

        </div>
      </div>
    </div>

    <div class="frenkel-carousel-controls">
      <button @click="prevArea">⟨</button>
      <button @click="nextArea">⟩</button>
    </div>

    <!-- Detalle SIN imagen (centrado) -->
    <div class="frenkel-detalle-area" v-if="currentServicio">
      <div class="frenkel-detalle-card">
        <h3 class="frenkel-detalle-title">
          {{ currentServicio.titles[selectedLang] || currentServicio.titles['es'] }}
        </h3>
        <p class="frenkel-detalle-text">
          {{ currentServicio.descriptions[selectedLang] || currentServicio.descriptions['es'] }}
        </p>
        <button class="frenkel-mas-btn" @click="goToServicio(currentServicio)">
          Conoce más
        </button>
      </div>
    </div>
  </section>
</template>

<script>
import { servicios } from '@/assets/data/data.ts'
import AOS from 'aos'
import 'aos/dist/aos.css'

export default {
  name: 'EcosistemaFrenkel',
  props: { selectedLang: { type: String, required: true } },
  data() {
    return {
      activeIndex: 0,
      ecosistemaKeys: ['industria-4-0', 'automatizacion-de-control', 'consultoria'],
      isSticky: false
    }
  },
  computed: {
    serviciosArr() { return this.ecosistemaKeys.map(key => ({ key, ...servicios[key] })) },
    totalItems() { return this.serviciosArr.length },
    anglePerItem() { return 360 / this.totalItems },
    radius() { return this.totalItems < 8 ? 300 : 320 + (this.totalItems - 8) * 30 },
    rotationStyle() { return { transform: `rotateY(-${this.activeIndex * this.anglePerItem}deg)` } },
    currentServicio() { return this.serviciosArr[this.activeIndex] || null }
  },
  methods: {
    getItemStyle(index) {
      const angle = index * this.anglePerItem
      return { transform: `rotateY(${angle}deg) translateZ(${this.radius}px)` }
    },
    nextArea() { this.activeIndex = (this.activeIndex + 1) % this.totalItems },
    prevArea() { this.activeIndex = (this.activeIndex - 1 + this.totalItems) % this.totalItems },
    setActive(index) { this.activeIndex = index },
    goToServicio(servicio) {
      window.scrollTo({ top: 0, behavior: 'smooth' })
      const path = servicio.slugs?.[this.selectedLang] || servicio.slugs?.es || '/servicios'
      this.$router.push(path)
    },
    handleScroll() { this.isSticky = window.scrollY > 80 }
  },
  watch: { selectedLang() { this.activeIndex = 0 } },
  mounted() {
    AOS.init({ duration: 800, once: true })
    setTimeout(() => AOS.refresh(), 300)
  }
}
</script>

<style>
.frenkel-ecosistema {
  font-family: 'Segoe UI', sans-serif;
  background: #f1f5f9;
  padding: 2rem 0;
  overflow-x: hidden;
  text-align: center
}

.frenkel-title {
  font-size: 2rem;
  margin-bottom: 2rem;
  font-weight: bold
}

/* Carrusel 3D */
.frenkel-carousel-wrapper {
  perspective: 1200px;
  width: 100%;
  height: 260px;
  margin-bottom: 1.5rem;
  display: flex;
  justify-content: center;
  align-items: center
}

.frenkel-carousel {
  width: 360px;
  height: 220px;
  position: relative;
  transform-style: preserve-3d;
  transition: transform 1.1s cubic-bezier(.8, 0, .22, 1)
}

.frenkel-carousel-item {
  position: absolute;
  width: 160px;
  height: 160px;
  left: 50%;
  top: 50%;
  margin-left: -80px;
  margin-top: -80px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: #fff;
  color: #0f172a;
  border-radius: 18px;
  font-size: .95rem;
  box-shadow: 0 6px 18px rgba(2, 12, 27, .12);
  cursor: pointer;
  opacity: .95;
  transition: transform .7s cubic-bezier(.8, 0, .22, 1), box-shadow .3s, opacity .3s, filter .3s;
  z-index: 1;
  text-align: justify;
  
}

.frenkel-carousel-item.active {
  box-shadow: 0 10px 28px rgba(35, 99, 192, .22);
  opacity: 1;
  filter: saturate(1.05)
}

.frenkel-item-img {
  width: clamp(54px, 7vw, 80px);
  height: clamp(54px, 7vw, 80px);
  object-fit: contain;
  margin-bottom: .55rem
}

.frenkel-item-label {
  display: block;
  line-height: 1.15;
  padding: 0 .4rem;
  font-weight: 600;
  text-align: center
}

/* Controles */
.frenkel-carousel-controls {
  display: flex;
  justify-content: center;
  gap: 1.5rem;
  margin-bottom: 2rem
}

.frenkel-carousel-controls button {
  padding: .55rem 1.35rem;
  font-size: 1.6rem;
  background: #2c74b8;
  color: #fff;
  border: none;
  border-radius: 12px;
  cursor: pointer;
  transition: background .3s, color .3s, border .3s
}

.frenkel-carousel-controls button:hover {
  background: #fff;
  color: #000;
  border: 1px solid #2c74b8
}

/* Detalle (centrado) */
.frenkel-detalle-area {
  display: flex;
  justify-content: center;
  margin-top: 2.5rem
}

.frenkel-detalle-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: .8rem;
  background: #fff;
  box-shadow: 0 0 14px rgba(0, 0, 0, .08);
  border-radius: 18px;
  padding: 1.6rem 1.8rem;
  max-width: 740px;
  text-align: center
}

.frenkel-detalle-title {
  margin: 0 0 .25rem 0
}

.frenkel-detalle-text {
  margin: 0
}

.frenkel-mas-btn {
  margin-top: .8rem;
  align-self: center;
  padding: .7rem 1.5rem;
  background: #2c74b8;
  color: #fff;
  font-weight: 700;
  border: none;
  border-radius: 10px;
  font-size: 1.06rem;
  cursor: pointer;
  box-shadow: 0 1px 4px rgba(40, 80, 200, .07);
  transition: background .3s, color .3s, border .3s
}

.frenkel-mas-btn:hover {
  background: #fff;
  color: #000;
  border: 1px solid #2c74b8
}

/* No selección */
.frenkel-ecosistema,
.frenkel-carousel,
.frenkel-carousel-item,
.frenkel-title,
.frenkel-detalle-card {
  user-select: none
}

/* ====== Responsive ====== */
@media (max-width: 900px) {
  .frenkel-title {
    font-size: 1.8rem;
    margin-bottom: 1.4rem
  }

  .frenkel-carousel-wrapper {
    height: 220px
  }

  .frenkel-carousel {
    transform: scale(.9);
    width: 300px;
    height: 190px
  }

  .frenkel-carousel-item {
    width: 150px;
    height: 150px;
    margin-left: -75px;
    margin-top: -75px
  }

  .frenkel-item-label {
    font-size: .9rem
  }

  .frenkel-carousel-controls button {
    font-size: 1.4rem;
    padding: .45rem 1.1rem
  }

  .frenkel-detalle-card {
    max-width: 640px;
    padding: 1.2rem 1.3rem
  }
}

@media (max-width: 600px) {
  .frenkel-title {
    font-size: 1.6rem;
    margin-bottom: 1rem
  }

  .frenkel-carousel-wrapper {
    height: 200px
  }

  .frenkel-carousel {
    transform: scale(.78);
    width: 260px;
    height: 170px
  }

  .frenkel-carousel-item {
    width: 128px;
    height: 128px;
    margin-left: -64px;
    margin-top: -64px
  }

  .frenkel-item-img {
    width: 56px;
    height: 56px
  }

  .frenkel-item-label {
    font-size: .85rem
  }

  .frenkel-detalle-card {
    max-width: 92vw;
    padding: 1rem
  }

  .frenkel-mas-btn {
    width: 100%;
    max-width: 320px
  }
}
</style>
